export const COIN_REGEXP = /[A-za-z0-9_\\.-]/;
